import { EditFormView as EditFormViewwWeb, useGetMappingByDatatype, getDefaultFormDataType } from '@tuqqi/web';

import { withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

const styles = theme => ({
    wrap: {

    }
});

const ViewDefaultFormView = (props) => {
	const {dispatch, oldInput} = props
	const {getMappingTitleWithOld} = useGetMappingByDatatype()

    
    if(!oldInput) return null
	const currentItem = getDefaultFormDataType(oldInput, getMappingTitleWithOld(oldInput.dataType))

	return <EditFormViewwWeb isReadonly={true} isCreating={false} customInputMapping={currentItem} />
}

const mapStateToProps = (state) => ({
	customInputService: state.services.customInputService,
	globalData: state.globalData,
	defaultInputTemplates: state.globalData.defaultInputTemplates ?? [],
	mappings: state.data.globalData.customInputMappings?.data ?? [],
})

const mapDispatchToProps = dispatch => {
    return { dispatch }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
))(ViewDefaultFormView);
